// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"bv_jp","breadcrumbs__items":"bv_jq","breadcrumbs__item":"bv_jr"};